import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/slack-notification-channel/constants';
import { slackNotificationChannelQueryKeys } from '@/modules/slack-notification-channel/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

/**
 * Clears the tenant notification channel, reverting hiring-manager notifications
 * to direct messages.
 */
export const useDeleteSlackNotificationChannelMutation = () => {
  return useMutation({
    mutationFn: () => fetchClient.DELETE(endpoints.notificationChannel, {}),
    onSettled: invalidateQuery(slackNotificationChannelQueryKeys.current()),
  });
};
